import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-1 px-2" }
const _hoisted_2 = { class: "my-1" }
const _hoisted_3 = { class: "p-1" }
const _hoisted_4 = { class: "py-1 px-2" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "m-1" }, null, -1)
const _hoisted_7 = { class: "py-1 px-2" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = { class: "py-1 px-2" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "py-1 px-2" }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Rating = _resolveComponent("Rating")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isVisible) = $event)),
    breakpoints: { '1600px': '40vw', '1200px': '50vw', '992px': '60vw', '768px': '75vw', '576px': '90vw' },
    closable: true,
    header: _ctx.vm.title,
    modal: true,
    style: { width: '30vw' },
    onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onCancel()))
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "p-button-text p-button-plain",
        label: _ctx.$t('common.close'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancel()))
      }, null, 8, ["label"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.vm?.intervieweeName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Rating, {
              modelValue: _ctx.vm.score,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vm.score) = $event)),
              stars: 5,
              readonly: "true",
              cancel: false
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.vm?.created ? _ctx.formatDate(_ctx.vm.created) : '-'), 1)
          ])
        ]),
        _hoisted_6,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("expert.reviewDetailModal.title")) + ":", 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.vm?.title || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("expert.reviewDetailModal.comment")) + ":", 1),
            _createElementVNode("p", {
              class: "mb-0",
              innerHTML: _ctx.vm?.comment || '-'
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("expert.reviewDetailModal.tags")) + ":", 1),
            _hoisted_15,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.tags, (tag) => {
              return (_openBlock(), _createBlock(_component_Tag, {
                key: `${tag}`,
                class: "mb-auto ml-auto",
                value: tag
              }, null, 8, ["value"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}